module.exports = __webpack_public_path__ + "static/media/sidebar_close.709051af.svg";